import React from 'react'
import styled from '@emotion/styled'

const CheckboxStyle = styled.div`
  box-shadow: 0 3px 6px rgba(0, 0, 0, 16%);
  width: 21px;
  height: 19px;
  .c-checkbox {
    > input[type='checkbox'] {
      width: 21px;
      height: 19px;
      cursor: pointer;
      opacity: 0;
      margin: 0;
      appearance: none;
      -webkit-appearance: none;
    }
    > div {
      display: grid;
      pointer-events: none;
      transition: transform 0.6s cubic-bezier(0.8, 0.4, 0.2, 1.4);
      transform-style: preserve-3d;
      > * {
        grid-area: 1/1;
      }
      > i {
        border: 1px solid #707070;
        border-radius: 5px;
        &:first-of-type {
          background: #3dc995;
          transform: translatez(-10px);
        }
        &:last-child {
          background: #fff;
          transform: translatez(10px);
        }
        &:nth-of-type(2) {
          height: 19px;
          transform: rotatex(90deg) rotatey(90deg);
          position: relative;
          top: 0;
          background: #025e3c;
          right: 5px;
        }
        &:nth-of-type(3) {
          height: 19px;
          transform: rotatex(90deg) rotatey(90deg);
          position: relative;
          top: 0;
          left: 5px;
        }
      }
    }
    display: grid;
    width: 21px;
    height: 19px;
    > * {
      grid-area: 1/1;
    }
  }
  input {
    &:checked {
      + {
        div {
          transform: rotatey(180deg);
        }
      }
    }
  }
`

interface CheckBox {
  isChecked: boolean
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const Checkbox = (props: CheckBox) => {
  return (
    <CheckboxStyle>
      <div className="c-checkbox">
        <input
          type="checkbox"
          id="un"
          checked={props.isChecked}
          onChange={props.handleChange}
        />
        <div>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
        </div>
      </div>
    </CheckboxStyle>
  )
}
export default Checkbox
